import base from '@/http/url_base';

export default {
  COMPTE: base.API_RH + '/employe-comptes',
  GET_REQUIREMENTS: base.API_RH + '/employe-comptes/requirements',
};
